import { FC } from 'react';

import CapsulePriceAddComponent from 'components/main/CapsulePrice/Add';

const CapsulePriceAdd: FC = () => <CapsulePriceAddComponent />;

export default CapsulePriceAdd;
